import Link from 'next/link';
import Image, { StaticImageData } from 'next/image';

type Props = {
   href: string;
   src: string | StaticImageData;
   alt?: string;
   width?: number | string;
   height?: number | string;
   responsive?: boolean;
   openInNewTab?: boolean;
};

const ImageLink = ({ href, src, alt, width, height, responsive, openInNewTab }: Props) => (
   <Link href={href}>
      <a {...(openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
         <Image
            src={src}
            alt={alt}
            width={width}
            height={height}
            layout={responsive ? 'responsive' : 'intrinsic'}
         />
      </a>
   </Link>
);

export default ImageLink;
